import type { WatcherFlagType } from '@atlassian/jira-issue-view-common-constants/src/flags.tsx';

export const showWatchersFlag = (watcherFlagType: WatcherFlagType) => ({
	type: watcherFlagType,
});

export type ShowWatchersFlag = ReturnType<typeof showWatchersFlag>;

export type Action = ShowWatchersFlag;
